import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@app/env';
import { Observable } from 'rxjs';
import { ProfessorApiService } from 'src/app/shared/services/professor-api.service';
import {
  SearchSchoolRequest,
  SearchSchoolResponse,
} from '../models/login.model';

const API = environment.apiProfessor;

@Injectable({
  providedIn: 'root',
})
export class SchoolSearchService extends ProfessorApiService {
  constructor() {
    super(inject(HttpClient));
  }

  async searchSchool(
    payload: SearchSchoolRequest,
  ): Promise<SearchSchoolResponse[]> {
    let url = '';

    if (payload.perfilacesso != undefined) {
      url = `login?tipo=ESCOLA&CPF=${payload.cpf}&DATABASE=${payload.local}&PERFILACESSO=${payload.perfilacesso}&CDESCOLA=${payload.cdescola}`;
    } else {
      url = `login?tipo=ESCOLA&CPF=${payload.cpf}&DATABASE=${payload.local}`;
    }
    const resultado: SearchSchoolResponse[] = await this.makeHttpRequest({
      url,
      method: 'GET',
      body: payload,
    });

    return resultado;
  }

  getSchools(payload: SearchSchoolRequest): Observable<SearchSchoolResponse[]> {
    const params = new HttpParams()
      .append('TIPO', 'ESCOLA')
      .append('CPF', payload.cpf)
      .append('DATABASE', payload.local)
      .append('PERFILACESSO', payload.perfilacesso)
      .append('CDESCOLA', payload.cdescola);

    return this.http.get<SearchSchoolResponse[]>(`${API}/login`, {
      params,
    });
  }
}
